import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.5 12.5h1.063l7.812-7.812-1.062-1.063L1.5 11.438zM0 14v-3.187L10.375.438A1.44 1.44 0 0 1 11.435 0q.294 0 .565.104t.5.334L13.563 1.5q.228.23.333.5.104.27.104.553 0 .3-.105.574-.105.272-.332.498L3.188 14zm9.834-9.834-.521-.541 1.062 1.063z"
    />
  </svg>
);
export default SvgEdit;
